import React, { useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"
import useWebNavigation, { useRoute as useWebRoute } from "../router/navigation"

export type NativeStackNavigationOptions = Record<string, unknown>
export type NativeStackScreenProps<T = Record<string, unknown>> = {
  navigation: Record<string, unknown>
  route: { params?: T; name?: string }
}
export type NavigationState = Record<string, unknown>
export type PartialState<T> = Partial<T>
export type NavigationAction = Record<string, unknown>
export type LinkingOptions = Record<string, unknown>

export function createNavigationContainerRef<T = unknown>() {
  return {
    isReady: () => true,
    navigate: () => {},
    goBack: () => {},
    canGoBack: () => true,
    getRootState: () => ({} as T),
    dispatch: () => {},
    current: null,
  }
}

export function createBottomTabNavigator<T = Record<string, unknown>>() {
  const Navigator = ({ children }: { children?: React.ReactNode }) => <>{children}</>
  const Screen = () => null
  return { Navigator, Screen }
}

export function createNativeStackNavigator<T = Record<string, unknown>>() {
  const Navigator = ({ children }: { children?: React.ReactNode }) => <Outlet />
  const Screen = () => null
  return { Navigator, Screen }
}

export function getStateFromPath() {
  return undefined
}

export function useNavigation<T = Record<string, unknown>>() {
  return useWebNavigation() as T
}

export function useRoute<T extends Record<string, unknown> = Record<string, unknown>>() {
  return useWebRoute<T>()
}

export function NavigationContainer({ children }: { children?: React.ReactNode }) {
  return <>{children}</>
}

export function useFocusEffect(effect: () => void | (() => void)) {
  const location = useLocation()
  useEffect(effect, [location.pathname])
}

export function useIsFocused() {
  return true
}

export function useHeaderHeight() {
  return 48
}

export default {
  createNavigationContainerRef,
  createBottomTabNavigator,
  createNativeStackNavigator,
  NavigationContainer,
}
